import { useHasAccessToken } from '@/auth/api';
import { useBackend, useBackendInfinite } from '@/backend';

export const useLoginActivities = () =>
  useBackendInfinite('account:get:auth/login-activities/', {});

export const useMe = () => {
  const hasAccessToken = useHasAccessToken();
  return useBackend(
    'account:get:users/me',
    {},
    {
      enabled: hasAccessToken,
      swrOptions: {
        dedupingInterval: 1000 * 60 * 15,
        refreshInterval: 1000 * 60 * 15,
        keepPreviousData: false,
      },
    },
  );
};
